document.addEventListener('DOMContentLoaded', () => {
  // Gallery thumbs => main image
  document.querySelectorAll('[data-ez-gallery]').forEach((gallery) => {
    const mainImg = gallery.querySelector('[data-ez-main-img]');
    if (!mainImg) return;

    const thumbs = gallery.querySelectorAll('[data-ez-thumb]');
    thumbs.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const src = btn.getAttribute('data-src');
        const srcset = btn.getAttribute('data-srcset');
        if (src) mainImg.setAttribute('src', src);
        if (srcset) mainImg.setAttribute('srcset', srcset);

        thumbs.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  });

  // Accordions (details / shipping / returns + FAQ)
  document.querySelectorAll('[data-ez-acc]').forEach((acc) => {
    const btn = acc.querySelector('[data-ez-acc-btn]');
    const panel = acc.querySelector('[data-ez-acc-panel]');
    if (!btn || !panel) return;

    btn.addEventListener('click', () => {
      const isOpen = acc.getAttribute('data-open') === 'true';
      acc.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  });
});